export const CONTENT_URL = 'ContentUrl';
export const COMPARISON_URL = 'ComparisonUrl';
export const DEALER_PAGE_URL = 'DealerPageUrl';
export const HOMEPAGE_URL = 'HomepageUrl';
export const NEWS_AND_ANALYSIS_URL = 'NewsAndAnalysisUrl';
export const SLIDESHOW_URL = 'SlideshowUrl';
